import { trackLinkClick } from '@snowplow/browser-plugin-link-click-tracking';
/**
 * Manually track a link click event.
 * Handles both JavaScript tag version (window.snowplow) and npm version (trackLinkClick).
 *
 * @param schema - The link click event data
 */
export const manuallyTrackLinkClick = (schema) => {
    // Try JavaScript tag version first (for apps using the Snowplow tag)
    if (window.snowplow) {
        window.snowplow('trackLinkClick', schema);
    }
    else {
        // Fallback to npm version (for apps using @snowplow/browser-tracker)
        trackLinkClick(schema);
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay1jbGljay10cmFja2luZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbGluay1jbGljay10cmFja2luZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sOENBQThDLENBQUM7QUFHOUU7Ozs7O0dBS0c7QUFDSCxNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLE1BQXVCLEVBQVEsRUFBRTtJQUN0RSxxRUFBcUU7SUFDckUsSUFBSSxNQUFNLENBQUMsUUFBUSxFQUFFLENBQUM7UUFDcEIsTUFBTSxDQUFDLFFBQVEsQ0FBQyxnQkFBZ0IsRUFBRSxNQUFNLENBQUMsQ0FBQztJQUM1QyxDQUFDO1NBQU0sQ0FBQztRQUNOLHFFQUFxRTtRQUNyRSxjQUFjLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDekIsQ0FBQztBQUNILENBQUMsQ0FBQyJ9